<template>
  <div>
    <div class="wrapper">
      <input type="radio" name="selects" id="options-7" @click="selectedGen('M')"/>
      <input type="radio" name="selects" id="options-8" @click="selectedGen('H')"/>
      <input type="radio" name="selects" id="options-9" @click="selectedGen('H,M')"/>
      <label for="options-7" class="options options-7">
        <div class="dot"></div>
        <span>Mujeres</span>
      </label>
      <label for="options-8" class="options options-8">
        <div class="dot"></div>
        <span>Hombre</span>
      </label>
      <label for="options-9" class="options options-9">
        <div class="dot"></div>
        <span>Todos</span>
      </label>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    selectedGen: function(selected) {
      this.$store.commit("setRHGen", selected)
    }
  }
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Fira+Sans:wght@300;400;600&display=swap");
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Fira Sans", sans-serif;
}
html,
body {
  display: grid;
  height: 100%;
  place-items: center;
  background: #0069d9;
  font-family: "Fira Sans", sans-serif;
}
.wrapper {
  background: #fff;
  height: 100px;
  border-radius: 5px;
  display: inline-flex;
  align-items: center;
}
.wrapper .options {
  background: #e0e0e0;
  height: 50px;
  width: 170px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  cursor: pointer;
  border: none;
  transition: all 0.3s ease;
  margin-right: 15px;
}

.wrapper .options .dot::before {
  position: absolute;
  content: "";
  top: 4px;
  left: 4px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  opacity: 0;
  transform: scale(1.5);
  transition: all 0.3s ease;
}
input[type="radio"] {
  display: none;
}
#options-7:checked:checked ~ .options-7,
#options-8:checked:checked ~ .options-8,
#options-9:checked:checked ~ .options-9 {
  border-color: #24c6ab;
  background: #24c6ab;
}
#options-7:checked:checked ~ .options-7 .dot,
#options-8:checked:checked ~ .options-8 .dot,
#options-9:checked:checked ~ .options-9 .dot {
  background: #fff;
}
#options-7:checked:checked ~ .options-7 .dot::before,
#options-8:checked:checked ~ .options-8 .dot::before,
#options-9:checked:checked ~ .options-9 .dot::before {
  opacity: 1;
  transform: scale(1);
}

#options-7:checked:checked ~ .options-7 span,
#options-8:checked:checked ~ .options-8 span,
#options-9:checked:checked ~ .options-9 span {
  color: #fff;
}

@media screen and (max-width: 1520px) {
  .wrapper .options {
    height: 40px;
    width: 120px;
    font-size: 14px;
  }
}

@media screen and (max-width: 1000px) {
  .wrapper .options {
    height: 30px;
    width: 90px;
    font-size: 10px;
  }
}

@media screen and (max-width: 770px) {
  .wrapper .options {
    height: 30px;
    width: 80px;
    font-size: 9px;
    margin-right: 10px;
  }
}
</style>
